var en = { exports: {} };
export {
  en as __module
};
//# sourceMappingURL=en2.js.map
